//Cache
let cache = {
  sessionID: '',
  productitle: 'Album Art Lyrics',
  productid: 33043245793332,
  details: {
    orientation: 'portrait',
    size: '4x6',
    frame: 'noframe',
    layout: 'classicportrait',
    disccolour: '#000000',
    disctextcolour: '#FFFFFF',
    labelcolour: '#c5b358',
    labeltextcolour: '#FFFFFF',
    manual: false,
    songlyrics: '',
    songlyricscursivefont: false,
    spotifycode: false,
    qrcode: false,
    spotifycodedata: '',
    qrcodedata: '',
    vinylcoverart: false,
    songdata: {
      title: '',
      artist: '',
      suri: '',
      img: null
    },
    ytid: '',
    text: [
      {
        family: 'Futura',
        color: '#FFFFFF',
        size: 12,
        options: {
          weight: 600
        },
        value: ''
      },
      {
        family: 'Futura',
        color: '#FFFFFF',
        size: 10,
        options: {
          weight: 400
        },
        value: ''
      }
    ],
    customerprovidedlyrics: false
  }
};

//Declare options for right menu
let designobj = {
  options: [
    {
      name: 'Size',
      icon: svgsize,
      description: 'Choose from our selection of print sizes. Changing the orientation alters the layout, you can adjust this in the layout tab.',
      variants: [
        {
          name: 'Size',
          id: 'size',
                    type: 'select',
                    variations: [
                        {
                            name: 'Orientation',
                            id: 'orientation',
                            options: [
                                {
                                    name: 'Square',
                                    value: 'square'
                                },
                                {
                                    name: 'Portrait',
                                    value: 'portrait'
                                },
                                {
                                    name: 'Landscape',
                                    value: 'landscape'
                                },
                            ]
                        },
                        {
                            name: 'Size',
                            id: 'size',
                            options: [
                                {
                                    name: '6" x 6"',
                                    value: '6x6',
                                    linked: 'square'
                                },
                                {
                                    name: '8" x 8"',
                                    value: '8x8',
                                    linked: 'square'
                                },
                                {
                                    name: '12" x 12"',
                                    value: '12x12',
                                    linked: 'square'
                                },
                                {
                                    name: '16" x 16"',
                                    value: '16x16',
                                    linked: 'square'
                                },
                                {
                                    name: '20" x 20"',
                                    value: '20x20',
                                    linked: 'square'
                                },
                                {
                                    name: '24" x 24"',
                                    value: '24x24',
                                    linked: 'square'
                                },
                                //Portrait
                                {
                                    name: '4" x 6"',
                                    value: '4x6',
                                    linked: 'portrait'
                                },
                                {
                                    name: '5" x 7"',
                                    value: '5x7',
                                    linked: 'portrait'
                                },
                                {
                                    name: '8" x 10"',
                                    value: '8x10',
                                    linked: 'portrait'
                                },
                                {
                                    name: '9" x 12"',
                                    value: '9x12',
                                    linked: 'portrait'
                                },
                                {
                                    name: 'A4',
                                    value: 'a4p',
                                    linked: 'portrait'
                                },
                                {
                                    name: '10" x 15"',
                                    value: '10x15',
                                    linked: 'portrait'
                                },
                                {
                                    name: '12" x 15"',
                                    value: '12x15',
                                    linked: 'portrait'
                                },
                                {
                                    name: '12" x 16"',
                                    value: '12x16',
                                    linked: 'portrait'
                                },
                                {
                                    name: 'A3',
                                    value: 'a3p',
                                    linked: 'portrait'
                                },
                                {
                                    name: '16" x 20"',
                                    value: '16x20',
                                    linked: 'portrait'
                                },
                                {
                                    name: 'A2',
                                    value: 'a2p',
                                    linked: 'portrait'
                                },
                                {
                                    name: '18" x 24"',
                                    value: '18x24',
                                    linked: 'portrait'
                                },
                                {
                                    name: '20" x 30"',
                                    value: '20x30',
                                    linked: 'portrait'
                                },
                                {
                                    name: '24" x 30"',
                                    value: '24x30',
                                    linked: 'portrait'
                                },
                                {
                                    name: 'A1',
                                    value: 'a1p',
                                    linked: 'portrait'
                                },
                                {
                                    name: '24" x 36"',
                                    value: '24x36',
                                    linked: 'portrait'
                                },
                                //Landscape
                                {
                                    name: '6" x 4"',
                                    value: '6x4',
                                    linked: 'landscape'
                                },
                                {
                                    name: '7" x 5"',
                                    value: '7x5',
                                    linked: 'landscape'
                                },
                                {
                                    name: '10" x 8"',
                                    value: '10x8',
                                    linked: 'landscape'
                                },
                                {
                                    name: '12" x 9"',
                                    value: '12x9',
                                    linked: 'landscape'
                                },
                                {
                                    name: 'A4',
                                    value: 'a4l',
                                    linked: 'landscape'
                                },
                                {
                                    name: '15" x 10"',
                                    value: '15x10',
                                    linked: 'landscape'
                                },
                                {
                                    name: '15" x 12"',
                                    value: '15x12',
                                    linked: 'landscape'
                                },
                                {
                                    name: '16" x 12"',
                                    value: '16x12',
                                    linked: 'landscape'
                                },
                                {
                                    name: 'A3',
                                    value: 'a3l',
                                    linked: 'landscape'
                                },
                                {
                                    name: '20" x 16"',
                                    value: '20x16',
                                    linked: 'landscape'
                                },
                                {
                                    name: 'A2',
                                    value: 'a2l',
                                    linked: 'landscape'
                                },
                                {
                                    name: '24" x 18"',
                                    value: '24x18',
                                    linked: 'landscape'
                                },
                                {
                                    name: '30" x 20"',
                                    value: '30x20',
                                    linked: 'landscape'
                                },
                                {
                                    name: '30" x 24"',
                                    value: '30x24',
                                    linked: 'landscape'
                                },
                                {
                                    name: 'A1',
                                    value: 'a1l',
                                    linked: 'landscape'
                                },
                                {
                                    name: '36" x 24"',
                                    value: '36x24',
                                    linked: 'landscape'
                                },
                            ]
                        }
                    ]
                }
      ]
    },
    {
            name: 'Framing',
            icon: svgframe,
            description: 'Choose from our selection of frame finishes.',
            variants: [
                {
                    name: 'Frame',
                    id: 'frame',
                    type: 'select',
                    variations: [
                        {
                            name: 'Frame',
                            id: 'frame',
                            options: [
                                {
                                    name: 'No Frame',
                                    value: 'noframe'
                                },
                                {
                                    name: 'Matt Black',
                                    value: 'mattblack'
                                },
                                {
                                    name: 'Matt Silver',
                                    value: 'mattsilver'
                                },
                                {
                                    name: 'Brushed Copper',
                                    value: 'brushedcopper'
                                },
                                {
                                    name: 'Brushed Champagne Gold',
                                    value: 'brushedchampagnegold'
                                },
                                {
                                    name: 'Brushed Steel',
                                    value: 'brushedsteel'
                                },
                                {
                                    name: 'Polished Silver',
                                    value: 'polishedsilver'
                                },
                                {
                                    name: 'Polished Dark Grey',
                                    value: 'darkpolishedgrey'
                                },
                                {
                                    name: 'Black Oak',
                                    value: 'blackoak'
                                },
                                {
                                    name: 'White Oak',
                                    value: 'whiteoak'
                                },
                                {
                                    name: 'Oak',
                                    value: 'oak'
                                },
                                {
                                    name: 'Wenge',
                                    value: 'wenge'
                                },
                            ]
                        },
                    ]
                }
            ]
        },
    {
      name: 'Song Search',
      icon: svgmusicnote,
      description: 'Choose a song.',
      variants: [
        {
          name: 'Search For A Song',
          id: 'songsearch',
          type: 'songsearch'
        }
      ]
    },
    {
      name: 'Style/Text',
      icon: svgpalette,
      description: 'Customise the design of the vinyl such as the disc colour, label colour or additional options.',
      variants: [
        {
                name: 'Lyrics',
                desc: 'As default we will source the lyrics for you, however you may add these yourself by selecting this checkbox.',
                id: 'enabletext',
                type: 'enabletext',
                variations: [
                  {
                    name: 'Provide Your Own Lyrics',
                    id: 'customerprovidedlyrics',
                    validation: {
                      checkid: 'manual',
                      errormsg: 'Manual details selected, you must enter the song lyrics/custom text yourself, or alternatively search and select a song if you want us to enter these for you.'
                    },
                    selected: {
                      name: 'Enter Song Lyrics',
                      divtype: 'textarea',
                      id: 'songlyrics',
                      validation: {
                        min: 350
                      }
                    },
                    
                  }
                ]
              },
        {
          name: 'Text Options',
          id: 'text',
          type: 'text',
          variations: [
            {
              name: 'Line 1',
              id: 'text1',
              moreinfo: {
                name: 'Text 1',
                image: `https://app.printframeco.com/ede7347d-48f3-4653-92e8-0c84f82467a6/vinyllyricstext1.jpg`,
                html: `Enter text to appear on the design.`
              }
            },
            {
              name: 'Line 2',
              id: 'text2',
              moreinfo: {
                name: 'Text 2',
                image: `https://app.printframeco.com/c3c442c2-9467-4b2f-9876-9b3db15f8b5f/vinyllyricstext2.jpg`,
                html: `Enter text to appear on the design.`
              }
            },
          ]
        },
      ]
    },
    {
      name: 'Layout',
      icon: svglayout,
      description: 'Select a design layout from the options below, these change depending on orientation of the print.',
      variants: [
        {},//blank update designobj search 'val' without using fixed index 1
        {
          name: 'Layout',
          id: 'layout',
          type: 'radio',
          variations: [
            //square
            {
              name: 'Classic',
              value: 'classicsquare',
              extrainfo: 'Recommended min size 6"x6"',
              validation: {
                option: 'size',
                type: 'min',
                value: '6x6'
              },
              icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.12482,0,0,0.821011,-5.42042,12.1123)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:1.06px;"/> </g> <g transform="matrix(1.08774,0,0,1.08774,-10.349,7.09058)"> <circle cx="55.481" cy="39.448" r="21.062"/> </g> <g transform="matrix(1,0,0,1,0.0885894,3.61894)"> <circle cx="49.911" cy="46.381" r="7.389" style="fill:white;"/> </g> </svg>`,
              for: {
                id: 'orientation',
                val: 'square'
              }
            },
            //portrait
            {
               name: 'Classic',
               value: 'classicportrait',
               extrainfo: 'Recommended min size 4"x6"',
               validation: {
                 option: 'size',
                 type: 'min',
                 value: '4x6'
               },
              icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.12482,0,0,0.821011,-5.42042,12.1123)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:1.06px;"/> </g> <g transform="matrix(1.08774,0,0,1.08774,-10.349,7.09058)"> <circle cx="55.481" cy="39.448" r="21.062"/> </g> <g transform="matrix(1,0,0,1,0.0885894,3.61894)"> <circle cx="49.911" cy="46.381" r="7.389" style="fill:white;"/> </g> </svg>`,
               for: {
                 id: 'orientation',
                 val: 'portrait'
               }
            },
            //Landscape
            {
              name: 'Classic',
              value: 'classiclandscape',
              extrainfo: 'Recommended min size 6"x4"',
              validation: {
                option: 'size',
                type: 'min',
                value: '6x4'
              },
              icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 100 100" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:1.5;"> <g transform="matrix(1.12482,0,0,0.821011,-5.42042,12.1123)"> <rect x="21.841" y="8.56" width="54.859" height="75.175" style="fill:none;stroke:rgb(0,0,9);stroke-width:1.06px;"/> </g> <g transform="matrix(1.08774,0,0,1.08774,-10.349,7.09058)"> <circle cx="55.481" cy="39.448" r="21.062"/> </g> <g transform="matrix(1,0,0,1,0.0885894,3.61894)"> <circle cx="49.911" cy="46.381" r="7.389" style="fill:white;"/> </g> </svg>`,
              for: {
                id: 'orientation',
                val: 'landscape'
              }
            },
          ]
        }
      ]
    },
  ]
};

//Design Templates
let layouttemplates = [
    //Square
    {
      name: 'Square',
      id: 'classicsquare',
      value: 'classicsquare',
      icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(0.758576,0,0,0.758576,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,35.2405,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> </svg>`,
      layout: {
        albumcover: {
          left: 0.5,
          originX: 'center'
        },
        songartist: {
          left: 0.5,
          originX: 'center'
        }
      },
    },
    //Portrait projection: 'cylindricalEqualArea',
    {
      name: 'Portrait',
      id: 'classicportrait',
      value: 'classicportrait',
      icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(0.758576,0,0,0.758576,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,35.2405,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> </svg>`,
      layout: {
        albumcover: {
          left: 0.5,
          originX: 'center'
        },
        songartist: {
          left: 0,
          originX: 'left'
        }
      },
    },
    //Landscape
    {
      name: 'Landscape',
      id: 'classiclandscape',
      value: 'classiclandscape',
      icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"> <g transform="matrix(0.758576,0,0,0.758576,35.2405,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,35.2405)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,213.044,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> <g transform="matrix(0.758576,0,0,0.758576,35.2405,213.044)"> <rect x="0" y="0" width="200" height="200"/> </g> </svg>`,
      layout: {
        albumcover: {
          left: 0.5,
          originX: 'center'
        },
        songartist: {
          left: 0,
          originX: 'center'
        }
      },
    },
];